import React from 'react';
import {
  ClientEngagementNoMatchMessage,
  instantMatchesAllowedCountryCode,
} from '@axiom/const';
import type { AfcSubmission } from '@axiom/validation';

import NoResults from '../../../public/static/svg/man-walking.svg';
import { Layout } from '../../layout/Layout/Layout';
import { LargeHeader } from '../../content/LargeHeader/LargeHeader';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { Gutter } from '../../layout/Gutter/Gutter';
import { Visible } from '../../layout/Visible/Visible';

export const ClientEngagementSelfServiceNoTalentMessage = ({
  children,
  submission,
}: {
  children: React.ReactNode;
  submission: AfcSubmission;
}) => {
  const isOpportunityOutsideOfUS =
    instantMatchesAllowedCountryCode !== submission.addressCountryCode;

  return (
    <Layout
      background="panelLight"
      boxShadow="default"
      direction="horizontal"
      name="self-service-no-matches"
      borderRadius="16px"
    >
      <Visible only="largeScreen" name="no-instant-matches-graphic">
        <NoResults width={256} height={256} />
      </Visible>
      <Gutter vertical="32px" horizontal="24px">
        <LargeHeader name="self-service-no-profile-header">
          {ClientEngagementNoMatchMessage.title}
        </LargeHeader>
        <Gutter top="16px">
          {isOpportunityOutsideOfUS ? (
            <Paragraph name="self-service-outside-of-us-message">
              We’re on it! We sent your requirements to your Axiom
              representative, and we will reach out to you within one business
              day.
            </Paragraph>
          ) : (
            <Paragraph name="self-service-no-profile-content">
              {ClientEngagementNoMatchMessage.content} Want to explore other
              options right now?
            </Paragraph>
          )}
          <Gutter top="16px">{children}</Gutter>
        </Gutter>
      </Gutter>
    </Layout>
  );
};
